// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { Service_abstract } from './../abstract/SagaSchema/Service_abstract';
export class Service extends Service_abstract {}
